"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var SwiperPlug = __importStar(require("swiper/react"));
var Row = function (_a) {
    var sport = _a.sport;
    var videos = ra_fetch_1.useApi('backend').index('public.videos', {
        type: 'live',
        sport: sport.name,
        resource: 'VideoFull',
    })[0];
    if (videos.data.length < 1) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'storybook-livestreams-row mb-8' },
        react_1.default.createElement("div", { className: 'storybook-livestreams-row-heading w-full flex items-center' },
            react_1.default.createElement(storybook_1.Texts.Heading, { className: 'mb-2 flex', type: 'h1' },
                sport.label,
                react_1.default.createElement(storybook_1.Icons.Icon, { name: sport.name })),
            react_1.default.createElement("div", { className: 'storybook-livestreams-row-videos ml-auto' },
                "Aantal livestreams: ",
                videos.data.length)),
        react_1.default.createElement(storybook_1.Layouts.Swiper, { spaceBetween: 15, breakpoints: {
                '0': {
                    'slidesPerView': 1.5,
                },
                '768': {
                    'slidesPerView': 3.5,
                },
            }, className: 'storybook-livestreams-row-swiper' }, videos.data.map(function (video, index) { return (react_1.default.createElement(SwiperPlug.SwiperSlide, { key: index },
            react_1.default.createElement(storybook_1.Videos.Card, { video: video }))); })));
};
exports.Row = Row;
